import { useMemo } from "react";
import { bool, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { isSafari } from "react-device-detect";
import { observer } from "mobx-react";
import { BreakdownColumns } from "@repo/utils";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useVisibilityModeCellClassName,
  usePresetFieldNames,
  useEstimateStructure,
  VisibilityButton,
  HeaderPriceActions,
  ValueCell,
} from "@tools";
import { Link, TooltipIcon } from "@components";
import Grid from "@material-ui/core/Grid";
import { PriceSumAlerts } from "./components/PriceSumAlerts"

export const TaskPriceCell = observer(({
  section,
  columnSettings,
  extendPadding,
  ...cellProps
}) => {
  const { t } = useTranslation();
  const { isProposal, isLibrary, allowEdition, showPdfCover } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  const { hide } = columnSettings;
  const { currencyObj } = structure.settings;
  
  const className = useVisibilityModeCellClassName(hide);
  
  const applyPin = useMemo(() => (
    columnSettings.applyPin && (!isSafari || !showPdfCover)
  ), [ columnSettings.applyPin, isSafari, showPdfCover ]);
  
  return (
    <ValueCell
      colName={ BreakdownColumns.PRICE }
      useDynamicWidth
      isHeader
      className={className}
      isSticky={applyPin}
      extendPadding={extendPadding || allowEdition || visibilityMode}
      // innerClassName={classnames(allowEdition && "relative")}
      {...cellProps}
    >
      <span className="preset-tableBreakdownHeader pt-price">
        {
          getFieldName("pt-price") +
          (currencyObj?.code ? ` (${ currencyObj.code || "" })` : "")
        }
      </span>
      
      {
        allowEdition &&
        <Grid
          item container
          justifyContent="center"
          alignItems="center"
          className="absolute w-max"
          style={{ top: -16 }}
        >
          <PriceSumAlerts section={section} />
          {
            isLibrary &&
            <TooltipIcon
              color="primary"
              className="text-sm"
              interactive
            >
              { t("views.editor.price_library_info.text") }
              <Link to="/home/settings/project">
                { t("views.editor.price_library_info.link") }
              </Link>
            </TooltipIcon>
          }
        </Grid>
      }
      
      <Grid
        item container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="absolute w-max"
        style={{ right: -16 }}
      >
        {
          visibilityMode &&
          <VisibilityButton
            size="tiny"
            hidden={hide}
            onChange={columnSettings.setHide}
          />
        }
        {
          allowEdition && !isLibrary &&
          <HeaderPriceActions column={columnSettings} />
        }
      </Grid>
      {/*{hasAverageRate(usedWorkTypes) && !isProposal && (*/ }
      {/*  <TooltipIcon*/ }
      {/*    style={{ fontSize: ".9rem" }}*/ }
      {/*    interactive*/ }
      {/*    className="color-warning"*/ }
      {/*  >*/ }
      {/*    {t("views.editor.average_breakdown_rate_info_tooltip")}*/ }
      {/*  </TooltipIcon>*/ }
      {/*)}*/ }
    </ValueCell>
  )
});

TaskPriceCell.propTypes = {
  section: object.isRequired,
  columnSettings: object.isRequired,
  extendPadding: bool,
}